module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jGQZw"))).then(() => module.bundle.root('ewmtE'));